export default __webpack_public_path__ + "static/media/collatzconjecture.76a75795.png";